import { SelectedGpsDevicePortInput } from './selected-gps-device-port-input.model';


export class GpsDeviceAddInput implements IGpsDeviceAddInput {
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The auto-generated id of the sim card details master" */
    deviceModelId!: number;
    /** The device name 500 character */
    deviceName!: string;
    /** The IMEI number with 500 character */
    imeiNumber!: string;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The manufacturing date should be with 10 character */
    manufacturingDate!: string;
    /** The installation date should be with 10 character */
    installationDate!: string;
    /** The special feature with 10 character */
    specialFeature!: string;
    /** The auto-generated id of the sim card details master */
    simCardDetailsId!: number;
    /** The auto-generated id of the sim card details master */
    secondarySimCardDetailsId!: number;
    /** The refresh intervale */
    refreshIntervale!: number;
    /** The device password with 200 character */
    devicePassword!: string;
    /** The refresh intervale */
    dataInterval!: number;
    /** The automatic config should be 0 or 1 */
    automaticConfig!: number;
    /** The distance calculation should be "Odometer" or "lating"  */
    distanceCalculation!: string;
    /** The distance calculation should be "Direct" or "From Lating"  */
    speedCalculation!: string;
    /** The auto-generated id of the time zone master" */
    timeZoneId!: number;
    /** The RFID timeoutDuration" */
    rfidTimeoutDuration!: number;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicleLicense!: number;
    /** The expiry date should be with 10 character */
    expiryDate!: string;
    /** The notify 0 for unselected, 1 for selected */
    notify!: number;
    /** The show expiryMessage days */
    showExpiryMessageDays!: number;
    /** The fuel consumption based on  should be  "+" or "-" */
    deviceDistanceVariation!: string;
    /** The device distance variation percentage */
    deviceDistanceVariationPercentage!: number;
    selectedGpsDevicePort!: SelectedGpsDevicePortInput[];

    constructor(data?: IGpsDeviceAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
            this.deviceModelId = _data["deviceModelId"];
            this.deviceName = _data["deviceName"];
            this.imeiNumber = _data["imeiNumber"];
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.manufacturingDate = _data["manufacturingDate"];
            this.installationDate = _data["installationDate"];
            this.specialFeature = _data["specialFeature"];
            this.simCardDetailsId = _data["simCardDetailsId"];
            this.secondarySimCardDetailsId = _data["secondarySimCardDetailsId"];
            this.refreshIntervale = _data["refreshIntervale"];
            this.devicePassword = _data["devicePassword"];
            this.dataInterval = _data["dataInterval"];
            this.automaticConfig = _data["automaticConfig"];
            this.distanceCalculation = _data["distanceCalculation"];
            this.speedCalculation = _data["speedCalculation"];
            this.timeZoneId = _data["timeZoneId"];
            this.rfidTimeoutDuration = _data["rfidTimeoutDuration"];
            this.vehicleLicense = _data["vehicleLicense"];
            this.expiryDate = _data["expiryDate"];
            this.notify = _data["notify"];
            this.showExpiryMessageDays = _data["showExpiryMessageDays"];
            this.deviceDistanceVariation = _data["deviceDistanceVariation"];
            this.deviceDistanceVariationPercentage = _data["deviceDistanceVariationPercentage"];
            if (Array.isArray(_data["selectedGpsDevicePort"])) {
                this.selectedGpsDevicePort = [] as any;
                for (let item of _data["selectedGpsDevicePort"])
                    this.selectedGpsDevicePort!.push(SelectedGpsDevicePortInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GpsDeviceAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new GpsDeviceAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        data["deviceModelId"] = this.deviceModelId;
        data["deviceName"] = this.deviceName;
        data["imeiNumber"] = this.imeiNumber;
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["manufacturingDate"] = this.manufacturingDate;
        data["installationDate"] = this.installationDate;
        data["specialFeature"] = this.specialFeature;
        data["simCardDetailsId"] = this.simCardDetailsId;
        data["secondarySimCardDetailsId"] = this.secondarySimCardDetailsId;
        data["refreshIntervale"] = this.refreshIntervale;
        data["devicePassword"] = this.devicePassword;
        data["dataInterval"] = this.dataInterval;
        data["automaticConfig"] = this.automaticConfig;
        data["distanceCalculation"] = this.distanceCalculation;
        data["speedCalculation"] = this.speedCalculation;
        data["timeZoneId"] = this.timeZoneId;
        data["rfidTimeoutDuration"] = this.rfidTimeoutDuration;
        data["vehicleLicense"] = this.vehicleLicense;
        data["expiryDate"] = this.expiryDate;
        data["notify"] = this.notify;
        data["showExpiryMessageDays"] = this.showExpiryMessageDays;
        data["deviceDistanceVariation"] = this.deviceDistanceVariation;
        data["deviceDistanceVariationPercentage"] = this.deviceDistanceVariationPercentage;
        if (Array.isArray(this.selectedGpsDevicePort)) {
            data["selectedGpsDevicePort"] = [];
            for (let item of this.selectedGpsDevicePort)
                data["selectedGpsDevicePort"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGpsDeviceAddInput {
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The auto-generated id of the sim card details master" */
    deviceModelId: number;
    /** The device name 500 character */
    deviceName: string;
    /** The IMEI number with 500 character */
    imeiNumber: string;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The manufacturing date should be with 10 character */
    manufacturingDate: string;
    /** The installation date should be with 10 character */
    installationDate: string;
    /** The special feature with 10 character */
    specialFeature: string;
    /** The auto-generated id of the sim card details master */
    simCardDetailsId: number;
    /** The auto-generated id of the sim card details master */
    secondarySimCardDetailsId: number;
    /** The refresh intervale */
    refreshIntervale: number;
    /** The device password with 200 character */
    devicePassword: string;
    /** The refresh intervale */
    dataInterval: number;
    /** The automatic config should be 0 or 1 */
    automaticConfig: number;
    /** The distance calculation should be "Odometer" or "lating"  */
    distanceCalculation: string;
    /** The distance calculation should be "Direct" or "From Lating"  */
    speedCalculation: string;
    /** The auto-generated id of the time zone master" */
    timeZoneId: number;
    /** The RFID timeoutDuration" */
    rfidTimeoutDuration: number;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicleLicense: number;
    /** The expiry date should be with 10 character */
    expiryDate: string;
    /** The notify 0 for unselected, 1 for selected */
    notify: number;
    /** The show expiryMessage days */
    showExpiryMessageDays: number;
    /** The fuel consumption based on  should be  "+" or "-" */
    deviceDistanceVariation: string;
    /** The device distance variation percentage */
    deviceDistanceVariationPercentage: number;
    selectedGpsDevicePort: SelectedGpsDevicePortInput[];
}

